import { TextComparison } from '@/app/utils/TextComparison';
import Highlighter from 'react-highlight-words';
import useReportViewerContext from '../report-viewer-context';
import MissingValue from './missing-value';
import TextTile from './text-with-label';
import { useTestTileContext } from '@/app/features/reports/components/test-tile/context';
import extractFieldValue from '@app.raytd.com/common/utils/test-suites/extractFieldValue';

const FastFillText = ({
    label,
    field_id,
    item: passedItem,
    hideLabel = false,
}: {
    label: string;
    field_id: string;
    item?: TextComparison;
    /**
     * SDA's per-tile column heading (Observations/Recommendations included) is hoisted to
     * render once above the results list instead of repeating per-tile — pass true to suppress
     * this field's own label there (raytd/web QA 108.03, item 1). The value still renders.
     */
    hideLabel?: boolean;
}) => {

    const { showFastFillQA, showMissingData } = useReportViewerContext();

    const { item: testItem } = useTestTileContext();
    const item = passedItem ?? testItem;

    const fieldName = field_id ? field_id.toLowerCase() : label.toLowerCase();
    const value = extractFieldValue(fieldName, item);
    const isEmpty = typeof value === 'string' ? value.trim().length === 0 : !value;
    const title = hideLabel ? '' : label;

    if (showFastFillQA && item.hasFastFillQA) {

        fieldName.startsWith('custom.') && console.debug('comparisoncon item', fieldName, value, item[`${fieldName}_unmatched`]);

        return (
            <TextTile title={title} >
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    <Highlighter
                        highlightStyle={{ backgroundColor: 'rgba(140, 65, 208, 0.25)' }} // 25% opacity
                        searchWords={item[`${fieldName}_unmatched`] || []}
                        textToHighlight={value?.replace(/\\n/g, '\n').trim()}
                        autoEscape={true}
                    />
                </div>
            </TextTile>
        )

    }

    if (isEmpty && showMissingData) {
        return (
            <TextTile title={title} >
                <MissingValue field={field_id} showMissingData={showMissingData} />
            </TextTile>
        )

    }

    return (
        <TextTile title={title} newLines={value?.includes('\n')}>
            {value ?? ''}
        </TextTile>
    )

}

export default FastFillText;